<template>
  <div class="demo">
    <el-transfer v-model="value" :filterable="filterable" :data="list" :filter-method="filterMethod"
      :target-order="targetOrder" :titles="titles" :props="props">
      <div slot-scope="{ option }">
        <span v-if="option[props.label].length < 8">{{ option[props.label] }}</span>
        <span v-else>
          <el-tooltip effect="dark" :content="option[props.label]" placement="top">
            <span>{{ option[props.label] }}</span>
          </el-tooltip>
        </span>
      </div>
    </el-transfer>
  </div>
</template>
<script>
import Sortable from "sortablejs";
export default {
  name: "SortTransfer",
  data() {
    return {
      value: [],//绑定值
    };
  },
  watch: {
    value(newData, oldData) {
      this.$emit('getTransfer', newData)
    }
  },
  props: {
    filterable: {
      type: Boolean,
      default: true
    },
    targetOrder: {
      type: String,
      default: 'push'
    },
    list: {
      type: Array,
      default: () => [],
    },
    titles: {
      type: Array,
      default: () => [],
    },
    props: {
      type: Object,
      default: () => ({}),

    }
  },
  mounted() {
    let el = document.querySelector(".el-transfer").querySelectorAll(".el-checkbox-group")[1];
    new Sortable(el, {
      forceFallback: false,
      onUpdate: event => {
        let box = this.$el.querySelector(".el-transfer").querySelectorAll(".el-checkbox-group")[1];
        let nums = this.$el.querySelector(".el-transfer").querySelectorAll(".el-checkbox-group")[1].childNodes.length;
        if (event.newIndex >= nums) {
          return;
        }
        let newIndex = event.newIndex;
        let oldIndex = event.oldIndex;
        let $label = box.children[newIndex];
        let $oldLabel = box.children[oldIndex];
        box.removeChild($label);
        if (newIndex < oldIndex) {
          box.insertBefore($label, $oldLabel);
        } else {
          box.insertBefore($label, $oldLabel.nextSibling);
        }
        let item = this.value.splice(oldIndex, 1);
        this.value.splice(newIndex, 0, item[0]);
      }
    });
  },
  methods: {
    //搜索方法
    filterMethod(query, item) {
      let regStr = query.replace(/\*/g, ".*");
      let reg = new RegExp(regStr);
      return reg.test(item[this.props.label]);
    },
    //获取已选择的列表
    getList(list) {
      this.value = list.map(res => {
        return res.id
      })
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-transfer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

::v-deep .el-transfer__buttons {
  ::v-deep button {
    display: block;
    margin: 0;

    &:first-child {
      margin-bottom: 12px;
    }
  }
}

.demo {
  text-align: left;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
  text-align: left;
  width: 300px;
  height: 300px;
  background-color: #42b983;
  overflow: scroll;
}

li {
  display: block;
  margin: 20px 10px;
  border: 1px solid #444;
}

a {
  color: #42b983;
}
</style>